
<template>
    <div class="row">
        <div class="col-lg-12">
            <ul class="nav nav-pills with-padding-bottom hidden-md-down profile-tabs" role="tablist">
            <li class="nav-item" v-for="(name, key) in tabs" :key="key">
                <a class="nav-link" data-toggle="tab" :href="linkToTab(key)" role="tab" :id="`link-${key}`">{{ name }}</a>
            </li>
        </ul>

            <!-- Smaller device tabs -->
            <ul class="nav nav-pills with-padding-bottom hidden-lg-up profile-tabs" role="tablist">
                <li class="nav-item dropdown">
                    <a class="nav-link active dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">Change Tab: <span class="tab-name">Profile</span></a>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" data-toggle="tab" v-for="(name, key) in tabs" :key="key" :href="linkToTab(key)" role="tab">{{ name }}</a>
                    </div>
                </li>
            </ul>

            <!-- Tab panes -->
            <div class="tab-content">
                <div class="tab-pane active" id="profile" role="tabpanel">
                    <caregiver-edit
                        :caregiver.sync=" localCaregiver "
                        :create=" create "
                        @continue=" nextTab() "
                        :role=" role "
                    />
                </div>
                <div class="tab-pane" id="address" role="tabpanel">
                    <caregiver-addresses
                        :role=" role "
                        :caregiver="localCaregiver"
                        :create="create"
                        v-if="unlocked"
                        @continue="nextTab()"
                        :url=" `${providerUrlPrefix}/${localCaregiver.id}/address`"
                    />
                </div>
                <div class="tab-pane" id="phones" role="tabpanel">
                    <caregiver-phone-numbers
                        :caregiver="localCaregiver"
                        :create="create"
                        v-if="unlocked"
                        @continue="nextTab()"
                        :role=" role == 'carrier_manager' ? role : 'admin' "
                    />
                </div>
                <div class="tab-pane" id="calllogs" role="tabpanel">

                    <support-call-list :role="role" :caregiver=" localCaregiver " />
                </div>
                <div class="tab-pane" id="messages" role="tabpanel">

                    <business-message-list :role=" role " :caregiver=" localCaregiver " />
                </div>
                <div class="tab-pane" id="textthread" role="tabpanel">

                    <text-thread :role=" role " :userId=" localCaregiver.id " />
                </div>
                <div class="tab-pane" id="documents" role="tabpanel">

                    <document-list
                        :initial-documents=" [] "
                        :userId=" localCaregiver.id "
                        :create=" create "
                        v-if=" unlocked "
                        :role=" role "
                    />
                    <b-row v-if="create">
                        <b-col>
                            <b-btn variant="success" size="lg" @click="nextTab()">Save and Continue</b-btn>
                        </b-col>
                    </b-row>
                </div>
                <div class="tab-pane" id="manage" role="tabpanel">

                    <b-card v-if=" !isCarrierManager ">
                        <b-button variant="primary" @click="passwordModal = true"><i class="fa fa-lock"></i> Reset Password</b-button>
                        <b-button variant="default" @click="sendEnrollmentEmail()" :disabled="!hasEmail" v-if="!enrolled"><i class="fa fa-mail-forward"></i> Send Enrollment Email</b-button>
                        <b-button variant="info" @click="createEnrollmentLetter()" v-if="!enrolled && caregiver.uses_enrollment_queue"><i class="fa fa-envelope-o"></i> Send Enrollment Letter</b-button>
                        <b-button variant="default" @click="sendTrainingEmail()" v-if="enrolled && localCaregiver.active"><i class="fa fa-mail-forward"></i> Send Training Email</b-button>
                        <b-button variant="info" :href="'/business/support/impersonate/' + localCaregiver.id" v-if="enrolled && localCaregiver.active"><i class="fa fa-user-secret"></i> Impersonate Provider</b-button>
                        <b-button variant="danger" @click="archiveCaregiver()" v-if=" localCaregiver.active"><i class="fa fa-times"></i> Deactivate Provider</b-button>
                        <b-button variant="info" @click="reactivateCaregiver()" v-else><i class="fa fa-refresh"></i> Re-activate Provider</b-button>
                        <div class="decommission-text" v-if="!localCaregiver.active">
                            Deactivated: {{ formatDateFromUTC(localCaregiver.decommissioned_at) }}
                            <span v-if="localCaregiver.decommission_reason"> - {{ localCaregiver.decommission_reason }}</span>
                        </div>
                    </b-card>
                    <b-card v-else>

                        <div class="decommission-text" v-if="!localCaregiver.active">
                            Deactivated: {{ formatDateFromUTC(localCaregiver.decommissioned_at) }}
                            <span v-if="localCaregiver.decommission_reason"> - {{ localCaregiver.decommission_reason }}</span>
                        </div>
                    </b-card>

                    <mfa-configure-collapsible v-if="this.caregiver.user" :user="this.caregiver.user" :sms_phone_number='this.caregiver.user.sms_phone_number' :is_mfa_enabled="this.caregiver.user.is_mfa_enabled"></mfa-configure-collapsible>

                    <admin-audit-log
                        :role="role"
                        :scopedUserId=" localCaregiver.id "
                    />

                    <b-row v-if="create">
                        <b-col>
                            <b-alert variant="warning" class="mb-4" show>
                                <strong>* Nothing will be sent at this time: DEV *</strong><br />
                                <strong>Upon clicking save, the following will occur:</strong><br/>
                                Enrollment Email will be sent if email exists.<br/>
                                Enrollment Letter will be mailed to the Claimant's address
                            </b-alert>
                            <b-btn variant="success" size="lg" :href="`/business/caregivers/${localCaregiver.id}`">Save</b-btn>
                        </b-col>
                    </b-row>
                </div>
                <div class="tab-pane" id="visits" role="tabpanel">

                    <business-shift-report :role=" role " :caregiver=" localCaregiver "></business-shift-report>
                </div>
                <div class="tab-pane" id="claimants" role="tabpanel">
                    <caregiver-client-list
                        :caregiver="localCaregiver"
                        :admin="true"
                        :role=" role "
                    />
                </div>
                <div class="tab-pane" id="upd" role="tabpanel" v-if=" !create && isOfficeUser ">
                    <upd-provider-interface
                        :caregiver="localCaregiver"
                        :role=" role "
                    />
                </div>
            </div>

            <reset-password-modal v-model="passwordModal" :url="'/business/caregivers/' + localCaregiver.id + '/password'"></reset-password-modal>
            <decommission-modal v-model="decommissionModal" :user="caregiver.user" @confirm="e => archiveCaregiver(true, e)" />
        </div>
    </div>
</template>

<script>

    import EnrollmentStatuses from "../../../mixins/EnrollmentStatuses";
    import FormatsDates from "../../../mixins/FormatsDates";
    import UsesRole from "../../../mixins/UsesRole";

    export default {

        name: "BusinessCaregiver",

        mixins: [ EnrollmentStatuses, FormatsDates, UsesRole ],

        props: {

            caregiver: {

                type: Object,
                default() {

                    return { id: 0 }
                }
            },
            create: Boolean,
            'sms_phone_number': {
                type: [String, Number],
                required: false,
                default: null
            },
            'is_mfa_enabled': {
                type: [String, Boolean, Number],
                required: false,
                default: null   
            },
            role: String,
        },

        data() {

            return {

                activeTab         : 'profile',
                localCaregiver    : this.caregiver,
                passwordModal     : false,
                decommissionModal : false,
            }
        },

        computed: {

            hasEmail(){

                if( this.caregiver.email ) return true;
                return false;
            },

            unlocked(){

                return this.localCaregiver.id > 0;
            },

            activeTabIndex(){
                return Object.keys(this.tabs).findIndex(item => { return item === this.activeTab; });
            },

            enrolled() {
                return this.isEnrolled(this.caregiver.enrollment_status);
            },

            tabs() {

                let tabs = {

                    'profile'   : 'Profile',
                    'address'   : 'Address',
                    'phones'    : 'Phone Numbers'
                };

                if( !this.create ){

                    tabs.calllogs   =   'Call Logs';
                    tabs.messages   =    'Messages';
                    tabs.textthread = 'Text Thread';
                    tabs.documents  =   'Documents';
                    tabs.manage     =      'Manage';
                    tabs.visits     =      'Visits';
                    tabs.claimants  =   'Claimants';
                    if( this.isOfficeUser ) tabs.upd = 'UPD Sync';
                }

                if( ! this.localCaregiver.active ){
                    delete tabs.documents;
                }

                return tabs;
            }
        },

        methods: {

            linkToTab(tab) {

                return '#' + tab;
            },

            nextTab() {

                let keys = Object.keys(this.tabs);
                if (this.activeTabIndex > keys.length-1) {
                    this.activeTab = keys[0];
                }
                this.activeTab = keys[this.activeTabIndex + 1];
            },

            updateTabClasses(){

                if (this.unlocked) {

                    $(".profile-tabs a[data-toggle=tab]").removeClass('disabled');
                    return;
                }
                $(".profile-tabs a[data-toggle=tab]:not(:first)").addClass('disabled');
            },

            archiveCaregiver( confirmed = false, reason = '') {

                if (! confirmed) {
                    this.decommissionModal = true;
                    return;
                }

                const form = new Form({ reason });
                form.post( `${this.providerUrlPrefix}/${this.caregiver.id}/deactivate` )
                    .then(({ data }) => this.localCaregiver = data.data);
            },

            reactivateCaregiver() {
                if (confirm('Are you sure you wish to re-activate ' + this.caregiver.name + '?')) {
                    const form = new Form();
                    form.post( `${this.providerUrlPrefix}/${this.caregiver.id}/reactivate` )
                        .then(({ data }) => this.localCaregiver = data.data);
                }
            },

            sendEnrollmentEmail() {

                const form = new Form();
                form.post( `${this.providerUrlPrefix}/${this.caregiver.id}/send_enrollment_email` );
            },

            sendTrainingEmail() {

                const form = new Form();
                form.post( `${this.providerUrlPrefix}/${this.caregiver.id}/send_training_email` );
            },

            createEnrollmentLetter() {
              const url = `/business/enrollment-queue/${this.caregiver.id}/letter`;
              const form = new Form();
              form.post( url);
            },
        },

        mounted() {
            this.localCaregiver = this.caregiver || {};

            const component = this;

            // Debugging for Development
            console.log("Caregiver Data");
            console.debug("Caregiver", this.caregiver);

            // Update tab classes
            $(".profile-tabs a[data-toggle=tab]:first").addClass('active');
            this.updateTabClasses();

            $(".profile-tabs a[data-toggle=tab]").on("click", function(e) {
                if (!component.unlocked) {
                    e.preventDefault();
                    alert('Use the "Continue" button once finished entering profile details.');
                    return false;
                }

                var $link = $(this);

                //remove active class from other tab-panes
                $('.tab-content:not(.' + $link.attr('href').replace('#','') + ') .tab-pane').removeClass('active');

                // activate tab-pane for active section
                $('.tab-content.' + $link.attr('href').replace('#','') + ' .tab-pane:first').addClass('active');
            });

            // Javascript to enable link to tab
            var url = document.location.toString();
            if (url.match('#')) {
                let tab = url.split('#')[1];
                $('.profile-tabs .nav-item a[href="#' +
                    tab + '"]').tab('show');
                component.activeTab = tab;
            }

            // Change hash for page-reload
            $('.profile-tabs .nav-item a').on('shown.bs.tab', function (e) {
                window.location.hash = e.target.hash;
                component.activeTab = e.target.hash.split('#')[1];
                window.scrollTo(0,0);
            })
        },

        watch: {
            unlocked() {
                this.updateTabClasses();
            },

            activeTab(val) {
                $('#link-' + val).tab('show');
            },
        }
    }
</script>

<style scoped>

</style>
